module.exports = __webpack_public_path__ + "img/no_lesson_points.7924fbc8.png";